<template>
  <div>
    <Calendar
      @onClickDay="onClickDay"
      @onChangeDate="onChangeDate"
      :courseDate="times"
      :showRightSide="true"
    >
    </Calendar>
    <div>
      <el-tabs
        class="courseTab"
        v-model="activeName"
        v-if="
          system_course_periods.length ||
          interactive_course_periods.length ||
          stove_course_periods.length
        "
      >
        <el-tab-pane :label="systemPeriodLabel" name="0">
          <StudyCalendarItem :list="system_course_periods" />
        </el-tab-pane>
        <el-tab-pane
          v-if="interactive_course_periods.length || !isGz"
          :label="interactivePeriodLable"
          name="1"
        >
          <StudyCalendarItem :list="interactive_course_periods" isInterActive />
        </el-tab-pane>
        <el-tab-pane :label="stovePeriodLabel" name="2">
          <StudyCalendarItem :list="stove_course_periods" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <MemberArrangeItem
      ref="arrange"
      v-show="false"
      :item="currentArrangeItem"
      :type="currentArrangeItem.type == 1 || currentArrangeItem.type == 2 ? 1 : 2"
      @leave="getData"
    ></MemberArrangeItem>
  </div>
</template>
<script>
import Calendar from '@/components/Calendar.vue';
import MemberArrangeItem from '@/modules/stu/views/periods/components/MemberArrangeItem.vue';
import StudyCalendarItem from './StudyCalendarItem';

import * as enums from '@/utils/enums.js';

export default {
  name: 'StudyCalendar',
  data() {
    return {
      showCourseClassTag: {
        2: '体验课',
        3: '正价课',
        4: '专属课',
      },
      activeName: '0',
      times: [],
      PeriodTypeEnum: {
        ALL: 0,
        OTO_CLASS: 1, //一对一 约课
        BIG_CLASS: 2, //大班课
        SMALL_CLASS: 3, //小班课
        PUBLIC_CLASS: 4, //公开课
        VIDEO_CLASS: 5, //点播课
        FACE_CLASS: 7, //面授课
        AUDIO_CLASS: 8, //音频课
        SYSTEM_CLASS: 9, //系统课
        PICTURE_CLASS: 10, // 图文课
        VIP_CLASS: 11, //vip课
        GROUP_CLASS: 15, //分组课课节
        DOUBLE_TEACHER_CLASS: 16, //双师课
        MULTIPLE_CLASS: 22, //混合课
      },
      interactive_course_periods: [],
      system_course_periods: [],
      stove_course_periods: [],
      leave: {
        course: {},
      },
      time: 0,
      currentArrangeItem: {},
      hideMore: null,
      homeworkPopupLock: false,
    };
  },
  components: {
    Calendar,

    MemberArrangeItem,
    StudyCalendarItem,
  },
  async created() {
    this.getStudySchedule();
    this.time = parseInt(new Date().getTime() / 1000);
    await this.getData();
    this.$emit('load');
  },
  mounted() {
    // 延迟上报
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'my_study_calendar_show',
      });
    }, 500);
    this.hideMore = () => {
      this.hideAll();
    };
    document.addEventListener('click', this.hideMore);
    this.visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        this.checkUnfinishedHomework();
      }
    };
    this.checkUnfinishedHomework();
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMore);
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
  },
  computed: {
    systemPeriodLabel() {
      return this.system_course_periods.length
        ? `系统课（${this.system_course_periods.length}）`
        : '系统课（0）';
    },
    interactivePeriodLable() {
      return this.interactive_course_periods.length
        ? `互动课（${this.interactive_course_periods.length}）`
        : '互动课（0）';
    },
    stovePeriodLabel() {
      return this.stove_course_periods.length
        ? `小灶答疑（${this.stove_course_periods.length}）`
        : '小灶答疑（0）';
    },
    isGz() {
      return location.hostname.indexOf('gz') === 0;
    },
  },
  methods: {
    async checkUnfinishedHomework() {
      if (this.homeworkPopupLock) return;
      this.homeworkPopupLock = true;
      setTimeout(() => {
        this.homeworkPopupLock = false;
      }, 1000); // 1秒内只弹一次

      const id = sessionStorage.getItem('period_id');
      const sub_type = sessionStorage.getItem('sub_type');
      if (!id || !sub_type) {
        return;
      }
      const storageKey = `HOMEWORK_COMPLETED_${id}_${sub_type}`;
      const hasEmitted = localStorage.getItem(storageKey);
      if (hasEmitted) {
        return; // 已经提示过了
      }

      try {
        const dialogResult = await this.$http.get('/backend-api/app/homework/popup', {
          period_id: id,
          scene: sub_type === 'zhibo' ? 'live' : 'playback',
          source: 'pc',
        });
        if (dialogResult.display) {
          localStorage.setItem(storageKey, 'true'); // 标记为已提示
          const result = await this.$confirm(dialogResult.content, dialogResult.title, {
            type: '',
            confirmButtonText: dialogResult.buttonMsg,
            cancelButtonText: '返回',
            showIcon: false,
          });
          this.$webSeeSendTrack({
            event_id: 'study_calendar_homework_dialog_show',
            event_type: 'show',
          });
          if (result) {
            this.$router.push({
              path: '/homework/intro',
              query: {
                hw_id: dialogResult.hwId,
                id: dialogResult.reportId || '0',
              },
            });
            this.$webSeeSendTrack({
              event_id: 'study_task_homework_dialog_Confirm',
              event_type: 'click',
            });
          } else {
            this.$webSeeSendTrack({
              event_id: 'study_task_homework_dialog_close',
              event_type: 'click',
            });
          }
        }
      } catch (error) {
        console.error('检查未完成作业失败:', error);
      }
    },

    async getStudySchedule(date) {
      this.times = await this.$http.get('/api/app/study/schedule', {
        date: (date ? new Date(date) : new Date()).format('yyyy-MM'),
      });
    },
    showDialog(row) {
      if (row.periods_type == 7) {
        this.showContentDialog = true;
        this.chapter_content = row.content;
      }
    },
    async getData() {
      let { interactive_course_periods, system_course_periods, stove_course_periods } =
        await this.$http.get(`/backend-api/app/study/dateCourse/${this.time}`);
      interactive_course_periods.forEach((item) => {
        item.mixType = item.course_type;
        item.course_type = item.periods_type || item.course_type;
        item.course_type_name = this.showCourseClassTag[item.course_classify_id] || '互动课';
        item.showTitle = item.subject_code_name
          ? `【${item.subject_code_name}】${item.title}`
          : item.title;

        this.handleSendViewTrack(item);
      });
      system_course_periods.forEach((item) => {
        item.mixType = item.course_type;
        item.course_type = item.periods_type || item.course_type;
        item.course_type_name = enums.CoursePeriodsType.getValue(item.course_type);
        item.showTitle = item.title;
        this.handleSendViewTrack(item);
      });
      stove_course_periods = stove_course_periods || [];
      stove_course_periods.forEach((item) => {
        item.mixType = item.course_type;
        item.course_type = item.periods_type || item.course_type;
        item.course_type_name = '小灶答疑';
        item.showTitle = item.title;
        this.handleSendViewTrack(item);
      });
      this.interactive_course_periods = interactive_course_periods;
      this.system_course_periods = system_course_periods;
      this.stove_course_periods = stove_course_periods;
      if (system_course_periods && system_course_periods.length) {
        this.activeName = '0';
      } else if (!this.isGz && interactive_course_periods && interactive_course_periods.length) {
        this.activeName = '1';
      } else if (stove_course_periods && stove_course_periods.length) {
        this.activeName = '2';
      }
    },
    isLive(courseType) {
      return (
        courseType === this.PeriodTypeEnum.BIG_CLASS ||
        courseType === this.PeriodTypeEnum.SMALL_CLASS ||
        courseType === this.PeriodTypeEnum.PUBLIC_CLASS ||
        courseType === this.PeriodTypeEnum.OTO_CLASS ||
        courseType === this.PeriodTypeEnum.GROUP_CLASS ||
        courseType === this.PeriodTypeEnum.MULTIPLE_CLASS
      );
    },
    isFace(courseType) {
      return this.PeriodTypeEnum.FACE_CLASS === courseType;
    },
    getPlayTypeTitle(courseType, playType) {
      if (this.isLive(courseType)) {
        if (playType === 1) {
          return '未开始';
        } else if (playType === 2) {
          return '直播中';
        } else if (playType === 3 || playType === 5) {
          return '已结束';
        } else if (playType === 4) {
          return '回放';
        } else if (this.isFace(courseType)) {
          if (playType === 1) {
            return '未开始';
          } else if (playType === 2) {
            return '开课中';
          } else if (playType === 3 || playType === 5) {
            return '已结束';
          } else if (playType === 4) {
            return '已结束';
          }
        } else {
          return '';
        }
      }
    },
    handleSendViewTrack(item) {
      this.$webSeeSendTrack({
        event_id: 'my_study_calendar_course_item_show',
        data: {
          cousrse_info: {
            course_id: item.course_basis_id,
            title: item.course_title,
            course_type: item.course_type,
          },
          section_info: {
            section_id: item.course_chapter_id,
            section_status: this.getPlayTypeTitle(item.course_type, item.live_status),
          },
          live_info: {
            platform: 'pc',
            roomId: item.room_video_id,
          },
          others: {
            from: 'study_calendar',
          },
        },
      });
    },
    onChangeDate(date) {
      this.getStudySchedule(date);
      this.interactive_course_periods = [];
      this.system_course_periods = [];
      this.stove_course_periods = [];
    },
    async onClickDay(date) {
      this.$webSeeSendTrack({
        event_id: 'my_course_study_calendar_click',
        event_type: 'click',
      });
      this.time = parseInt(new Date(date).getTime() / 1000);
      await this.getData();
    },
    async goToPlay(item, type) {
      if (item.interception_info) {
        this.currentItem = item;
        this.showContactTeacherDialog = true;
        return;
      }
      if (item.status == 2 && item.is_go_to_study == 0) {
        this.showSoldOut = true;
        return;
      }
      if (item.course_type == 16) {
        if (!type) {
          type = 2;
        }
      } else if (!type) {
        type = 1;
      }
      if (type == 1 && (item.live_status == 2 || item.live_status == 4)) {
        return;
      }
      if (type == 2 && (item.min_live_status == 2 || item.min_live_status == 4)) {
        return;
      }
      if (item.valid_status != 1) {
        return this.$info('该课程已过期，无法继续学习');
      }
      if (item.course_type != 1) {
        await this.$services.CourseService.checkLimit(item.course_basis_id, item.course_chapter_id);
      }
      this.$livePlay(item.course_basis_id, item.course_type, {
        id: item.course_chapter_id,
        title: item.title,
        type: type,
        period_id: item.periods_id,
      });
    },
    hideAll() {
      this.interactive_course_periods.forEach((item) => {
        item.showMore = false;
      });
      this.system_course_periods.forEach((item) => {
        item.showMore = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.courseTab {
  ::v-deep {
    .el-tabs__header {
      padding: 13px 32px 13px 8px;
      border-radius: 8px;
      background: #fff;
      margin-bottom: 24px;

      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }

        .el-tabs__active-bar {
          display: none;
          border-radius: 20px;
          background: #f55;
        }

        .el-tabs__item {
          position: relative;
          height: 30px;
          margin: 0 16px;
          padding: 0 8px;
          line-height: 30px;
          color: #706e79;
          font-size: 16px;

          &.is-active {
            color: #000 !important;
            font-weight: 500;

            &::after {
              content: '';
              position: absolute;
              display: inline-block;
              bottom: 0;
              height: 2px;
              width: 24px !important;
              border-radius: 20px;
              background: #f55;
              left: 50% !important;
              transform: translateX(-50%) !important;
            }
          }
        }
      }
    }
  }
}
</style>
